<template>
  <div>
    <c-modal
      v-if="showModal"
      title="Representative Details"
      size="md"
      @close="closeModal"
    >
      <div class="modal-body">
        <div style="margin-top: 100px;">
          <speaker-item
            :name="presenter.full_name"
            :title="presenter.title"
            :photo="presenter.photo_url"
            :description="presenter.bio"
          />
        </div>
      </div>
      <div class="modal-footer">
        <div class="buttons-footer-wrapper">
          <c-button
            theme="default"
            size="md"
            icon="fa-close"
            @click="closeModal"
            uppercase
            fill
          >Close</c-button>

          <c-button
            v-if="presenter.forward_appointment_schedule_url"
            fill
            uppercase
            theme="primary"
            icon="fa-calendar-clock"
            :href="`${presenter.forward_appointment_schedule_url}?attendeeId=${attendeeId}`"
          >Schedule a Meeting</c-button>
        </div>
      </div>
    </c-modal>
  </div>
</template>

<script>
import SpeakerItem from "../../speakers/speaker-item";

export default {
  components: {
    SpeakerItem
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    presenter: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      sponsorId: this.$route.params.sponsorId,
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:showModal', false);
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-footer-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
